import { BORAL_YELLOW, BORAL_GREEN } from 'Constants/Theme/Theme.constants'
import Colors from 'Support/Theme/Colors/Colors'
import { Order, PlusLoadStatus } from 'types/Order'

/**
 * @param {boolean} isSmall Is small screen used
 * @returns {Object} Chart options object
 */
export const getPieChartOptions = (isSmall: boolean, order: Order) => {
  const arrivedColor = BORAL_GREEN
  const inTransitColor = BORAL_YELLOW
  const scheduledColor = Colors.raven[200]
  const plusLoadColor = getPlusLoadColor(order)

  // we need to do few checks for smaller screens as graph layout is different from larger screens
  const options: any = {
    chartArea: { bottom: 0, height: `300px`, left: 0, right: 0, top: 0, width: `300px` },
    is3D: false,
    backgroundColor: `transparent`,
    legend: {
      position: `none`, // isSmall ? `left` : `labeled`,
    },
    pieHole: 0.7,
    pieSliceText: `none`,
    slices: {
      0: { color: plusLoadColor, visibleInLegend: false },
      1: { color: scheduledColor, visibleInLegend: false },
      2: { color: inTransitColor, visibleInLegend: false },
      3: { color: arrivedColor, visibleInLegend: false },
    },
    tooltip: {
      trigger: `none`,
    },
    width: isSmall ? '200' : '300',
    height: isSmall ? '200' : '300',
  }
  return options
}

function getPlusLoadColor(order: Order) {
  if (!order || !order.details.plusLoadDetails) {
    return Colors.raven[500]
  }
  const { status } = order.details.plusLoadDetails
  if (status === PlusLoadStatus.NOT_SUBMITTED || status === PlusLoadStatus.REJECTED) {
    return Colors.raven[500]
  }
  return Colors.raven[500]
}
